export default __webpack_public_path__ + "static/media/menuitem-noimage.2c2150ed.svg";